<template>
    <div class="global-search"
         :class="{ 'position-relative': isDesktop }">
        <div v-show="!showSearch"
             v-if="isDesktop"
             class="d-flex justify-content-center align-items-center position-relative advanced-search"
             @click="activateSearch">
            <svg xmlns="http://www.w3.org/2000/svg"
                 fill="none"
                 height="16"
                 width="16"
                 viewBox="0 0 24 24"
                 class="search-icon">
                <path d="M16.4153 16.4153L20 20M18.5455 11.2727C18.5455 15.2893 15.2894 18.5454 11.2728 18.5454C7.25612 18.5454 4 15.2893 4 11.2727C4 7.2561 7.25612 4 11.2728 4C15.2894 4 18.5455 7.2561 18.5455 11.2727Z"
                      stroke-width="2"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
            </svg>
            <div class="text">
                <translate translation-key="header.searchPlaceholder"
                           :replacements="{name: searchPlaceholders[0]}" />
            </div>
            <div class="search-trigger">
                /
            </div>
        </div>
        <div v-if="!isDesktop"
             class="mobile-advanced-search d-flex justify-content-center align-items-center">
            <svg :class="{ 'd-none': showSearch }"
                 xmlns="http://www.w3.org/2000/svg"
                 fill="none"
                 height="27"
                 width="27"
                 stroke="#c7cbe2"
                 viewBox="0 0 24 24"
                 class="search-icon mr-2"
                 @click="activateSearch">
                <path d="M16.4153 16.4153L20 20M18.5455 11.2727C18.5455 15.2893 15.2894 18.5454 11.2728 18.5454C7.25612 18.5454 4 15.2893 4 11.2727C4 7.2561 7.25612 4 11.2728 4C15.2894 4 18.5455 7.2561 18.5455 11.2727Z"
                      stroke-width="2"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
            </svg>
            <div :class="{ 'd-none': !showSearch }"
                 class="nav-search"
                 @click="closeSearch">
                <div id="search-wrapper"
                     class="active mr-2">
                    <div class="container">
                        <div class="search-toggle" />
                    </div>
                </div>
            </div>
        </div>
        <div v-show="showSearch"
             class="search-dropdown"
             :class="{ 'mobile-search-dropdown': !isDesktop, 'active': showSearch }">
            <div class="d-flex justify-content-between align-items-center position-sticky search-block border-bottom mb-1">
                <input id="search"
                       ref="searchInput"
                       v-model="searchQuery"
                       :placeholder="getTrans('header.searchPlaceholder',
                                              `Search ${searchPlaceholders[0]}`,
                                              {name: searchPlaceholders[0]})"
                       class="mb-0 form-control">
                <div class="close-icon"
                     @click="closeSearch">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         fill="currentColor"
                         height="12"
                         width="12"
                         viewBox="0 0 24 24"
                         class="sc-1pyr0bh-0 KQOVh">
                        <path d="M18 6L6 18M18 18L6 6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                        <svg />
                    </svg>
                </div>
            </div>
            <div class="search-dropdown-inner">
                <div class="search-loader"
                     :class="[{ 'search-loader--active': loading }]">
                    <div class="wrp">
                        <Loader size="48px"
                                :text="getTrans('cryptocurrencies.loading', 'Loading...')" />
                    </div>
                </div>
                <div class="search-results">
                    <div v-if="resultsCount > 0">
                        <div v-for="(category, index) in assets"
                             :key="index">
                            <div v-if="category.length > 0">
                                <div class="d-flex justify-content-between align-items-center search-header pb-1 mt-2">
                                    <span class="category">
                                        <translate :translation-key="'header.' + index" />
                                    </span>
                                </div>
                                <a v-for="asset in category"
                                   :key="asset.ranking_general"
                                   :href="asset.url"
                                   class="search-result">
                                    <div class="coin-info w-75">
                                        <img v-if="asset.logo"
                                             :src="asset_cdn(asset.logo, 22)"
                                             class="asset-logo asset-logo__24"
                                             width="24"
                                             height="24"
                                             :alt="asset.name"
                                             :title="asset.name">
                                        <div v-else
                                             class="asset-logo-default" />
                                        <span class="name">
                                            {{ asset.name }}
                                        </span>
                                        <span v-if="index === 'cryptocurrencies'"
                                              class="coin-item-symbol">
                                            {{ asset.currency_code }}
                                        </span>
                                        <span v-if="index === 'dapps'"
                                              class="coin-item-symbol text-uppercase">
                                            {{ asset.protocol_slug }}
                                        </span>
                                    </div>
                                    <div v-if="asset.ranking_general"
                                         class="coin-rank d-flex justify-content-end">
                                        #{{ asset.ranking_general }}
                                    </div>
                                </a>
                                <div class="text-center see-more-block">
                                    <a :href="route(getRouteByIndex(index))"
                                       class="category link text-capitalize"
                                       @click="closeSearch">
                                        <translate translation-key="cryptocurrencies.seeMore" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div v-if="newsArticles?.length > 0"
                             class="news-search">
                            <div class="d-flex justify-content-between align-items-center pb-1 mt-2">
                                <span class="category">
                                    <translate translation-key="header.cryptoNews" />
                                </span>
                            </div>
                            <a v-for="newsArticle in newsArticles"
                               :key="newsArticle.id"
                               :href="newsArticle.url"
                               class="news-search-result">
                                <div class="news-info">
                                    <img v-if="newsArticle.featured_image_url"
                                         :src="asset_cdn(newsArticle.featured_image_url, 120)"
                                         class="news-image"
                                         :alt="newsArticle.title"
                                         :title="newsArticle.title">
                                    <div class="d-flex flex-column pl-2">
                                        <div class="news-category mb-1">
                                            {{ formattedCategory(newsArticle.category) }}
                                        </div>
                                        <div class="news-title">
                                            {{ newsArticle.title }}
                                        </div>
                                        <div class="date">
                                            {{ formattedDate(newsArticle.published_at) }}
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <div class="text-center see-more-block">
                                <a :href="route('news')"
                                   class="category link text-capitalize">
                                    <translate translation-key="cryptocurrencies.seeMore" />
                                </a>
                            </div>
                        </div>
                        <div v-if="videos?.length > 0"
                             class="news-search">
                            <div class="d-flex justify-content-between align-items-center pb-1 mt-2">
                                <span class="category">
                                    <translate translation-key="header.cryptoVideos" />
                                </span>
                            </div>
                            <a v-for="video in videos"
                               :key="video.id"
                               :href="route('videos') + '?video-id=' + video.video_id"
                               class="news-search-result">
                                <div class="news-info">
                                    <img v-if="video.thumbnail_url"
                                         :src="asset_cdn(video.thumbnail_url, 120)"
                                         class="news-image"
                                         :alt="video.title"
                                         :title="video.title">
                                    <div class="d-flex flex-column pl-2">
                                        <div class="news-category mb-1">
                                            <translate translation-key="videos.video" />
                                        </div>
                                        <div class="news-title">
                                            {{ video.title }}
                                        </div>
                                        <div class="date">
                                            {{ formattedDate(video.published_at) }}
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <div class="text-center see-more-block">
                                <a :href="route('videos')"
                                   class="category link text-capitalize">
                                    <translate translation-key="cryptocurrencies.seeMore" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-else
                         class="no-results">
                        <translate translation-key="header.searchNoResults" />
                    </div>
                </div>
                <div :class="['gradient-background bottom', { 'show': !hasScrolledToBottom }]" />
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { asset_cdn, route } from '@/js/helpers/helpers';
    import { getTrans } from '@/js/helpers/getTrans';
    import { useMenuStore } from '@/js/store/menu/MenuStore';
    import Loader from '../../components/Loader.vue';
    import { useCustomDeviceSize } from '@/js/composables/useCustomDeviceSize';

    const DEBOUNCE_DELAY = 500;
    const PLACEHOLDER_INTERVAL = 4000;

    export default {
        name: 'GlobalSearch',
        components: { Loader },
        setup() {
            const { isMenuDesktop: isDesktop } = useCustomDeviceSize();

            return {
                isDesktop,
            };
        },
        data() {
            return {
                placeholderInterval: null,
                assets: {},
                newsArticles: {},
                videos: {},
                resultsCount: 1,
                searchQuery: '',
                searchPlaceholders: [
                    getTrans('header.cryptos'),
                    getTrans('header.exchanges'),
                    getTrans('header.dapps'),
                    getTrans('header.nftCollections'),
                    getTrans('header.cryptoNews'),
                    getTrans('header.cryptoVideos'),
                ],
                showSearch: false,
                hasScrolledToBottom: false,
                loading: false,
                firstLaunch: false,
                assetsRouteMapping: {
                    cryptocurrencies: 'cryptocurrencies-index',
                    exchanges: 'exchanges-index',
                    dapps: 'dapp-rankings',
                    nftCollections: 'nft-collection-rankings',
                },
                keydownHandler: null,
                clickHandler: null,
            };
        },
        watch: {
            searchQuery(newSearchQuery) {
                if (this.debouncedSearch) {
                    clearTimeout(this.debouncedSearch);
                }

                this.loading = true;

                this.debouncedSearch = setTimeout(() => {
                    this.search(newSearchQuery);
                }, DEBOUNCE_DELAY);
            },
        },
        created() {
            this.keydownHandler = (event) => {
                if (event.keyCode === 191) {
                    event.preventDefault();
                    this.activateSearch();
                }
                if (event.keyCode === 27) {
                    event.preventDefault();
                    this.closeSearch();
                }
            };

            this.clickHandler = (event) => {
                if (!(event.target.closest('.search-icon') || event.target.closest('.search-dropdown') || event.target.closest('.advanced-search') || event.target.closest('.countdown-container'))) {
                    this.closeSearch();
                }
            };

            window.addEventListener('keydown', this.keydownHandler);
            window.addEventListener('click', this.clickHandler);
            this.firstLaunch = true;
        },
        mounted() {
            this.placeholderInterval = window.setInterval(() => {
                this.changeSearchPlaceholderText();
            }, PLACEHOLDER_INTERVAL);
            const searchDropdownInner = document.querySelector('.search-dropdown-inner');
            searchDropdownInner.addEventListener('scroll', this.handleScroll);
        },
        beforeUnmount() {
            const searchDropdownInner = document.querySelector('.search-dropdown-inner');
            searchDropdownInner.removeEventListener('scroll', this.handleScroll);

            if (this.placeholderInterval) {
                clearInterval(this.placeholderInterval);
                this.placeholderInterval = null;
            }

            window.removeEventListener('keydown', this.keydownHandler);
            window.removeEventListener('click', this.clickHandler);
        },
        methods: {
            getTrans,
            checkIfScrolledToBottom() {
                const searchDropdownInner = document.querySelector('.search-dropdown-inner');

                if (searchDropdownInner.scrollHeight <= searchDropdownInner.clientHeight) {
                    this.hasScrolledToBottom = true;
                } else {
                    this.hasScrolledToBottom = searchDropdownInner.scrollTop + searchDropdownInner.clientHeight >= searchDropdownInner.scrollHeight;
                }
            },
            search() {
                if (this.firstLaunch) {
                    this.loading = true;
                    window.setTimeout(() => {
                        this.loading = false;
                    }, 500);
                    this.firstLaunch = false;
                }
                axios.get(`/api/search?search=${this.searchQuery}`)
                    .then((res) => {
                        this.assets = res.data.assets;
                        this.newsArticles = res.data.newsArticles;
                        this.videos = res.data.videos;
                        this.resultsCount = res.data.resultsCount;
                    })
                    .finally(() => {
                        this.loading = false;
                        this.checkIfScrolledToBottom();
                    });
            },
            activateSearch() {
                const menuStore = useMenuStore();

                menuStore.isMobileNavOpen = false;
                this.search();
                this.showSearch = true;
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            },
            closeSearch() {
                this.showSearch = false;
                this.searchQuery = '';
            },
            getRouteByIndex(index) {
                return this.assetsRouteMapping[index];
            },
            handleScroll(event) {
                const searchDropdownInner = event.target;
                this.hasScrolledToBottom = searchDropdownInner.scrollTop + searchDropdownInner.clientHeight >= searchDropdownInner.scrollHeight;
            },
            formattedCategory(category) {
                return category.replace(/-/g, ' ');
            },
            formattedDate(date) {
                const options = { month: 'long', day: 'numeric', year: 'numeric' };
                const dateObject = new Date(date);

                return dateObject.toLocaleDateString('en-US', options);
            },
            changeSearchPlaceholderText() {
                const placeholder = this.searchPlaceholders.shift();
                this.searchPlaceholders = this.searchPlaceholders.concat(placeholder);
            },
            route,
            asset_cdn,
        },
    };
</script>

<style scoped lang="scss">
@use "@/sass/design-system/variables" as variables;
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/partials/z-index" as ZIndex;
@use "@/sass/partials/mixins" as mixins;

.global-search {
    display: block;
}

.advanced-search {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px;
    border-radius: 8px;
    margin-left: 8px;
    background-color: legacyVariables.$lavender-mist;
    -webkit-box-align: center;
    color: #4800ab;
    cursor: pointer;

    svg {
        width: 16px;
        height: 16px;
        margin: 0;
        stroke: #4800ab;
    }

    .text {
        display: flex;
        overflow: hidden;
        width: 170px;
        flex: 1 1 0;
        margin-left: 4px;
        font-size: 12px;
        font-weight: 600;
        text-overflow: ellipsis;
        white-space: nowrap;

        @media (min-width: 1240px) and (max-width: 1284px) {
            width: 110px !important;
        }

        @media (min-width: 1285px) and (max-width: 1329px) {
            width: 130px !important;
        }

        @media (min-width: 1330px) and (max-width: 1380px) {
            width: 150px !important;
        }
    }

    .search-trigger {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        background-color: #a2a0f4;
        color: legacyVariables.$dark-purple;
        font-size: 15px;
        line-height: 18px;
        text-align: center;
    }
}

.search-dropdown {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    min-width: 350px;
    height: auto;
    max-height: 550px;
    padding: 2px 6px 6px 6px;
    border-radius: 8px;
    background: legacyVariables.$white;
    box-shadow: 0 14px 25px rgba(128, 138, 157, 0.24);
    color: legacyVariables.$black;

    @media (max-width: 1239px) {
        min-width: unset;
    }

    input {
        height: calc(1.5em + 8px + 2px);
        padding: 4px;
        border: none !important;
        box-shadow: none !important;
    }

    .search-block {
        z-index: ZIndex.$search-block-z-index;
        top: 0;
        padding: 4px 0;
        background-color: legacyVariables.$white;

        &.border-bottom {
            border-bottom: 1px solid legacyVariables.$border !important;
        }
    }

    .close-icon {
        display: flex;
        width: 16px;
        height: 16px;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        margin-right: 8px;
        background-color: rgb(207, 214, 228);
        -webkit-box-align: center;
        -webkit-box-pack: center;
        color: rgb(255, 255, 255);
        cursor: pointer;

        svg {
            width: 12px;
            height: 12px;
        }
    }

    .search-dropdown-inner {
        position: relative;
        max-height: 500px;
        overflow-x: hidden;
        overflow-y: scroll;

        .gradient-background {
            position: sticky;
            width: 100%;
            height: 100px;
            margin-top: -100px;
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.3s ease-in-out;

            &.show {
                opacity: 1;
            }

            &.bottom {
                bottom: 0;
                left: 0;
                background-image: linear-gradient(to top, legacyVariables.$white 0%, transparent 100%) !important;
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
            }
        }

        .search-results {
            min-height: 175px;

            .category {
                padding: 0 11px;
                color: gray;
                font-size: 10px;
                line-height: 13px;
                text-transform: uppercase;

                &.link {
                    position: relative;
                    z-index: ZIndex.$see-more-z-index;
                    color: legacyVariables.$faded-purple;
                    font-size: 12px;
                    font-weight: 400;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

            .no-results {
                min-height: 175px;
                padding: 10px;
                font-size: 14px;
                font-weight: 300;
                text-align: center;
            }

            .search-result {
                display: flex;
                min-height: 36px;
                align-items: center;
                justify-content: space-between;
                padding: 8px;
                border-radius: 8px;
                cursor: pointer;
                margin-inline: 2px;

                &:hover {
                    background-color: rgb(248, 250, 253);
                }

                &:focus-visible {
                    outline-color: legacyVariables.$menu-background;
                }

                .coin-info {
                    display: flex;
                    align-items: center;
                    -webkit-box-align: center;
                    font-weight: 500;

                    .name {
                        @include mixins.one-line-clamp;
                        max-width: 100%;
                        margin-left: 8px;
                        color: rgb(23, 25, 36);
                        font-size: 14px;
                        font-weight: 600;
                    }

                    .coin-item-symbol {
                        position: relative;
                        margin-left: 7px;
                        color: rgb(128, 138, 157);
                        font-size: 12px;
                        font-weight: 600;
                        line-height: 24px;
                    }
                }

                .coin-rank {
                    min-width: 50px;
                    margin: 0;
                    color: rgb(128, 138, 157);
                    font-size: 12px;
                    font-weight: 500;
                }
            }

            .news-search-result {
                display: flex;
                min-height: 70px;
                align-items: center;
                padding: 5px;
                border-radius: 8px;
                cursor: pointer;

                .news-info {
                    display: flex;

                    .news-image {
                        max-width: 40%;
                        max-height: 100px;
                        padding: 2px;
                        border: 1px solid legacyVariables.$border;
                        border-radius: 8px;
                    }

                    .news-title {
                        display: -webkit-box;
                        overflow: hidden;
                        -webkit-box-orient: vertical;
                        color: legacyVariables.$black;
                        font-size: 13px;
                        font-weight: 500;
                        -webkit-line-clamp: 2;
                        line-height: 1.3;
                    }

                    .news-category {
                        margin-top: 5px;
                        color: #c02b3f;
                        font-size: 10px;
                        font-weight: 400;
                        line-height: 1;
                        text-transform: uppercase;
                    }

                    .date {
                        margin-top: 5px;
                        color: rgb(128, 138, 157);
                        font-size: 10px;
                        font-weight: 400;
                        line-height: 1;

                        &::before {
                            padding: 0 0 3px;
                            margin: 0 5px 0 0;
                            content: "\f017";
                            float: left;
                            font-family: legacyVariables.$font-awesome;
                            font-weight: 500;
                            text-align: left;
                        }
                    }
                }

                &:hover {
                    background-color: legacyVariables.$light;
                }
            }
        }

        .see-more-block {
            padding-bottom: 4px;
            line-height: 1;

            a {
                z-index: 0 !important;
            }
        }

        .news-search .see-more-block {
            padding-bottom: 8px;
        }
    }
}

.mobile-advanced-search {
    cursor: pointer;
}

.nav-search {
    @media (max-width: 1239px) {
        display: flex;

        #search-wrapper {
            padding: 10px;
            margin: 0 -10px 0 5px;

            .container {
                position: relative;
                width: 22px;
                height: 16px;
                cursor: pointer;

                .search-toggle {
                    position: absolute;
                    top: 8px;
                    width: 77%;
                    height: 2px;
                    border-radius: 4px;
                    background-color: #c7cbe2;
                    transform: rotate(45deg) !important;
                    transition: transform 200ms ease 0.5s, background-color 0s cubic-bezier(0.6, 0, 0.15, 1) 0s;

                    &::before {
                        position: absolute;
                        display: block;
                        width: 100%;
                        height: 2px;
                        border-radius: 4px;
                        background-color: #c7cbe2;
                        content: "";
                        transform: translateY(0) !important;
                        transition: transform 300ms ease 0s, background-color 0s cubic-bezier(0.6, 0, 0.15, 1) 0s;
                    }

                    &::after {
                        position: absolute;
                        display: block;
                        width: 100%;
                        height: 2px;
                        border-radius: 4px;
                        background-color: #c7cbe2;
                        content: "";
                        transform: translateY(0) rotate(-90deg) !important;
                        transition: transform 300ms ease 0s, background-color 0s cubic-bezier(0.6, 0, 0.15, 1) 0s;
                    }
                }
            }
        }
    }
}

.mobile-search-dropdown {
    position: absolute;
    top: legacyVariables.$navbar-height;
    right: 0;
    bottom: 0;
    left: 0;
    display: block !important;
    width: 100%;
    height: 0;
    max-height: calc(100vh - 100px);
    opacity: 0;
    pointer-events: none;
    transition: height 0.2s ease;

    input {
        font-size: 16px;
    }

    &.active {
        z-index: ZIndex.$mobile-search-dropdown-z-index;
        height: calc(100vh - 100px);
        opacity: 1;
        pointer-events: all;
    }

    .search-dropdown-inner {
        max-height: 100%;
    }
}

.search-loader {
    position: absolute;
    z-index: ZIndex.$search-loader-z-index;
    display: none;
    width: 100%;
    height: calc(100% - 48px);
    backdrop-filter: blur(2px);
    text-align: center;

    &--active {
        display: block;
    }

    .wrp {
        position: relative;
        top: 50px;
    }
}

.dark-theme {
    .search-dropdown {
        border-radius: 6px;
        background: legacyVariables.$dark-theme-bg;

        input {
            background: legacyVariables.$dark-theme-bg;
            color: variables.$baseWhite;
        }

        .search-block {
            background-color: legacyVariables.$dark-theme-bg;

            &.border-bottom {
                border-bottom: 1px solid legacyVariables.$dark-theme-border !important;
            }

            .close-icon {
                background-color: legacyVariables.$body-color;
            }
        }

        .search-dropdown-inner {
            .gradient-background.bottom {
                background-image: linear-gradient(to top, legacyVariables.$dark-theme-bg 0%, transparent 100%) !important;
            }

            .form-control {
                color: variables.$baseWhite;

                &::placeholder {
                    color: legacyVariables.$medium-grey;
                }
            }

            .category {
                color: legacyVariables.$dark-theme-secondary-grey;
            }

            .search-result:hover {
                background-color: legacyVariables.$dark-grey;
            }

            .coin-rank,
            .category {
                color: legacyVariables.$medium-grey;
            }

            .no-results {
                color: variables.$baseWhite;
            }

            .news-search-result {
                .news-title {
                    color: variables.$baseWhite !important;
                }

                .news-image {
                    border: 1px solid legacyVariables.$dark-theme-border !important;
                }

                &:hover {
                    background-color: #343a40;
                }
            }
        }
    }
}
</style>
